const COLUMNS_GROUPS = [
  {
    id: "date",
    label: "DATE",
    widget: "text",
    width: 150
  },
  {
    id: "invoice",
    label: "INVOICE#",
    widget: "text",
    width: 180
  },
  {
    id: "ordernumber",
    label: "ORDER NUMBER",
    widget: "text",
    width: 200
  },
  {
    id: "customername",
    label: "CUSTOMER NAME",
    widget: "text",
    width: 250
  },
  {
    id: "status",
    label: "STATUS",
    widget: "text",
    width: 150
  },
  {
    id: "duedate",
    label: "DUE DATE",
    widget: "text",
    width: 150
  },
  {
    id: "amount",
    label: "AMOUNT",
    widget: "number",
    width: 150
  },
  {
    id: "balancedue",
    label: "BALANCE DUE",
    widget: "number",
    width: 150
  }
];

const ROW_DATA = [
  {
    date: "15/12/2025",
    invoice: "INV-56012",
    ordernumber: "SO-45021",
    customername: "Arvind Textiles",
    status: "Paid",
    duedate: "20/12/2025",
    amount: 180000,
    balancedue: 0
  },
  {
    date: "12/12/2025",
    invoice: "INV-55980",
    ordernumber: "SO-44990",
    customername: "Prime Garments",
    status: "Overdue",
    duedate: "10/12/2025",
    amount: 95000,
    balancedue: 95000
  },
  {
    date: "10/12/2025",
    invoice: "INV-55955",
    ordernumber: "SO-44955",
    customername: "Meenakshi Fabrics",
    status: "Partially Paid",
    duedate: "18/12/2025",
    amount: 120000,
    balancedue: 40000
  }];

export {COLUMNS_GROUPS,ROW_DATA};